import { useEffect, useRef } from 'react';

/**
 * Limpa o operador escolhido no filtro quando ele não está mais entre os
 * sugeridos — ex.: trocou de funil e a pessoa não participa do novo nem tem
 * lead nele. Sem isso a tela continuaria filtrando por alguém invisível.
 *
 * `operators === undefined` é "carregando", não "lista vazia": só age com a
 * lista do contexto atual já carregada.
 */
export function useClearStaleOperator(
  selectedId: string | null,
  operators: ReadonlyArray<{ id: string }> | undefined,
  onClear: () => void,
): void {
  const onClearRef = useRef(onClear);
  onClearRef.current = onClear;

  useEffect(() => {
    if (!selectedId || !operators) return;
    if (!operators.some((operator) => operator.id === selectedId)) onClearRef.current();
  }, [selectedId, operators]);
}
